"use strict";
"use es6";

module.exports = require('./lib/index');